<template>
  <div class="dropdown language-dropdown" :class="{'is-active' : openDropdown}">
    <div v-if="openDropdown" class="outside" @click="openDropdown = false"></div>
    <div class="dropdown-trigger" @click="openDropdown = !openDropdown">
      <button class="button" aria-haspopup="true" aria-controls="dropdown-menu">
        <span>{{ $t("language") }}</span>
        <span class="icon is-small">
          <i class="fas fa-angle-down" aria-hidden="true"></i>
        </span>
      </button>
    </div>
    <div v-if="openDropdown" class="dropdown-menu" id="dropdown-menu" role="menu" @click="openDropdown = !openDropdown">
      <div class="dropdown-content">
        <a class="dropdown-item" @click="saveLanguage('en')">
          English
        </a>
        <a class="dropdown-item" @click="saveLanguage('fr')">
          Français
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import componentState from '@/mixins/component-state'
import auth from '@/mixins/auth'
import localStorage from 'store'

const languageKey = 'language'

export default {
  mixins: [componentState, auth],
  data: function () {
    return {
      openDropdown: false
    }
  },
  methods: {
    saveLanguage: function (selectedLanguage) {
      this.$i18n.locale = selectedLanguage
      if (this.isLoggedIn) {
        const settings = { language: selectedLanguage }
        this.$store.dispatch('updateUserSettings', { username: this.currentUser.userName, settings })
      } else {
        localStorage.set(languageKey, selectedLanguage)
      }
    }
  }
}
</script>

<style lang="scss" scoped>

  @import '~styles/utils.scss';

  .language-dropdown {
    padding: 2rem 2rem 0rem 2rem;
    font-weight: 600;
    width: 100%;
    z-index: 9;
    @include mobile {
      padding: 1rem 1rem 0rem 1rem;
    }
    @include mini-mobile {
      padding-left: .5rem;
    }
    .dropdown-trigger button {
      display: flex;
      justify-content: space-between;
      width: 10rem;
    }
    .dropdown-menu {
      min-width: 10rem;
      margin-left: 2rem;
      @include mobile {
        margin-left: 1rem
      }
      @include mini-mobile {
        margin-left: .5rem;
      }
    }
  }

  .outside {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0px;
    left: 0px;
  }
</style>
